import React from 'react'

import Slide from '../components/Slide'
import WhoWeAreSection from '../components/WhoWeAreSection';
import IndustriesWeServe from '../components/IndustriesWeServe';
import WhyChooseUs from '../components/WhyChooseUs';
import TestimonialsSection from '../components/TestimonialsSection';
import PartnersSection from '../components/PartnersSection';


import ProductCatalog from '../components/ProductCatalog';

function Home() {
  return (
    <div>
        <section>
            <Slide/>
            <WhoWeAreSection/>
            <ProductCatalog/>
            <IndustriesWeServe/>
            <WhyChooseUs/>
            <TestimonialsSection/>
            <PartnersSection/>
        </section>
    </div>
  )
}

export default Home
